import { render, staticRenderFns } from "./OBVSystem.vue?vue&type=template&id=69c560a0&scoped=true"
import script from "./OBVSystem.vue?vue&type=script&lang=js"
export * from "./OBVSystem.vue?vue&type=script&lang=js"
import style0 from "./OBVSystem.vue?vue&type=style&index=0&id=69c560a0&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c560a0",
  null
  
)

export default component.exports